import { Button, Card, Descriptions, Divider, Flex, Form, Grid, Image, message, Modal, Select, Typography } from "antd";
import { Icon } from "@iconify/react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Link, useNavigate, useParams } from "react-router";
import { registrationService } from "../../services/registration.service";
import { userService } from "../../services/user.service";
import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../config/api.config";
import RenderIf from "../../components/RenderIf";
import { useAuth } from "../../hooks/useAuth";

export default function ProcessRegistrationDetail(){

  const [surveyorForm] = Form.useForm()

  const breakpoint = Grid.useBreakpoint()

  const navigate = useNavigate()

  const { id } = useParams()

  const { user } = useAuth()

  const [previewImage, setPrevieImage] = useState('')

  const { data: registration  } = useQuery({
    queryKey: ['detailRegistration', id],
    queryFn: () => registrationService.getAcceptedDataById(id),
  })

  const { data: surveyor  } = useQuery({
    queryKey: ['surveyor', registration],
    queryFn: () => userService.getSurveyorByMarketing(),
  })

  const changeSurveyorMutation = useMutation({
    mutationKey: ['changeSurveyor'],
    mutationFn: val => registrationService.changeSurveyor(id, val),
    onSuccess: () => {
      message.success("Surveyor berhasil diganti")
    },
    onError: () => {
      message.error("Terjadi Kesalahan")
    }

  })

  const handelSubmit = val => {
    Modal.confirm({
      centered: true,
      title: "Pemberitahuan",
      content: "Yakin ingin mengganti surveyor ? ",
      onOk: () => changeSurveyorMutation.mutate(val)
    })
  }

  useEffect(() => {
    surveyorForm.setFieldValue('surveyorId', registration?.data?.acceptance?.surveyorId)
  }, [registration, surveyorForm])

  console.log(breakpoint)

  return (
    <>
      <Card
        title="Detail Registrasi"
      >
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          size="small"
          styles={{ label: { width: breakpoint.lg ? 200 : null } }}
          title="Informasi Pelanggan"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { span: 2, label: 'Nama Pelanggan', children: registration?.data?.nama_kustomer },
            { label: 'No Telepon', children: registration?.data?.nomor_kustomer },
            { label: 'Email', children: registration?.data?.email_kustomer },
            { label: 'Kota', children: registration?.data?.kota_kustomer },
            { label: 'Kecamatan', children: registration?.data?.kecamatan_kustomer },
            { label: 'Kelurahan', children: registration?.data?.kelurahan_kustomer },
            { label: 'Jalan', children: registration?.data?.jalan_kustomer },
            { span: 2, label: 'No Rumah', children: registration?.data?.no_rumah_kustomer },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RT', children: registration?.data?.rt_kustomer?.toString().padStart(3, "0") },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RW', children: registration?.data?.rw_kustomer?.toString().padStart(3, "0") },
          ]}
        />
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          style={{ marginTop: 24 }}
          size="small"
          title="Penanggung Jawab"
          styles={{ label: { width: breakpoint.lg ? 200 : null } }}
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { span: 2, label: 'Nama Penanggung Jawab', children: registration?.data?.nama_pic },
            { label: 'No Telepon', children: registration?.data?.nomor_pic },
            { label: 'Email', children: registration?.data?.email_pic },
            { label: 'Kota', children: registration?.data?.kota_pic },
            { label: 'Kecamatan', children: registration?.data?.kecamatan_pic },
            { label: 'Kelurahan', children: registration?.data?.kelurahan_pic },
            { label: 'Jalan', children: registration?.data?.jalan_pic },
            { span: 2, label: 'No Rumah', children: registration?.data?.no_rumah_pic },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RT', children: registration?.data?.rt_pic?.toString().padStart(3, "0") },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RW', children: registration?.data?.rw_pic?.toString().padStart(3, "0") },
          ]}
        />
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          style={{ marginTop: 24 }}
          styles={{ label: { width: breakpoint.lg ? 180 : 120 } }}
          size="small"
          title="Informasi Bangunan"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { 
              label: 'Kebutuhan Air',
              children: registration?.data?.kebutuhan_air + 'm3'
            },
            { label: 'Ketersediaan Tangki', children: registration?.data?.ketersediaan_tangki },
            { label: 'Peruntukan Bangunan', span: 2, children: registration?.data?.peruntukan_bangunan },
            { label: 'Titik Lokasi Bangunan', span: 2, children: registration?.data?.alamat_bangunan },
            { label: 'Area Bisnis', span: 2, children: registration?.data.ab.NAMA_AB },
            { label: 'PA/PC', span: 2, children: registration?.data.ab.PAPC_CODE },
            { label: 'EZ', span: 2, children:registration?.data.ab.AREA == 'WEST' ? registration?.data.ab.BLOCKNO : registration?.data.ab.EZ_CODE },
          ]}
        />
        <Descriptions
          column={1}
          bordered
          style={{ marginTop: 24 }}
          styles={{ label: { width: 110 }, content: { width: '100%' } }}
          size="small"
          title="Dokumen"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { 
              label: 'KTP', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.ktp}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.data?.ktp}
                    >
                      <Link to={registration?.data?.ktp && `${API_BASE_URL}/files/registration/${registration?.data?.ktp}?download=true`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.ktp}`)}
                      disabled={!registration?.data?.ktp}
                    >
                      Lihat
                    </Button>
                  </Flex>
                  
                </Flex>
              )
            },
            { 
              label: 'KK', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.kk}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.data?.kk}
                    >
                      <Link to={registration?.data?.kk && `${API_BASE_URL}/files/registration/${registration?.data?.kk}?download=true`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.kk}`)}
                      disabled={!registration?.data?.kk}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'PBB', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.pbb ?? '-'}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.data?.pbb}
                    >
                      <Link to={registration?.data?.pbb && `${API_BASE_URL}/files/registration/${registration?.data?.pbb}?download=true`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.pbb}`)}
                      disabled={!registration?.data?.pbb}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'Bangunan', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.bangunan}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >

                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.data?.bangunan}
                    >
                      <Link to={registration?.data?.bangunan && `${API_BASE_URL}/files/registration/${registration?.data?.bangunan}?download=true`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.bangunan}`)}
                      disabled={!registration?.data?.bangunan}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
          ]}
        />
        <Divider/>
        <RenderIf when={user.user.subdivision == 'SPV' || user.user.subdivision == 'Marketing'} >
          <Typography.Title level={5} style={{ marginTop: 20 }} >
            Terima Pendaftaran
          </Typography.Title>
          <Form
            form={surveyorForm}
            layout="vertical"
            onFinish={handelSubmit}
          >
            <Form.Item label="Assign Surveyor" name={'surveyorId'} rules={[{ required: true }]} >
              <Select
                options={surveyor?.data?.map(e => ({ value: e.id, label: e.name }))}
                disabled={registration?.data?.status != 'survey'}
              />
            </Form.Item>
          </Form>
          <Flex key={'1'} justify="end" gap={12} style={{ marginTop: 28 }} >
            <Button 
              variant="outlined" 
              color="danger" 
              onClick={() => navigate('/registration/process')}
            >
              Batal
            </Button>
            <Button 
              variant="solid" 
              color="primary"
              onClick={() => surveyorForm.submit() }
              disabled={registration?.data?.status != 'survey'}
            >
              Assign
            </Button>
          </Flex>
        </RenderIf>
      </Card>
      <Modal
        open={previewImage.length > 0}
        centered
        title="Gambar"
        onCancel={()=> setPrevieImage('')}
      >
        <Image src={previewImage} />
      </Modal>
    </>
  )
}